// MARK - Define
// ************************************************************************
// const CheckoutTimeout = 30 * 60 * 1000
const CheckoutTimeout = 30 * 60 * 1000


// MARK -
// ************************************************************************
const uiStore = {
    state: {
        previewProduct   : null,    // 存储预览的商品
        previewShow      : false,   // 是否显示预览弹窗
        checkoutTimestamp: 0,       // 购物车结算时间戳
    },

    getters: {
        /**
         * @func 获取预览商品
         */
        getPreviewProduct(state) {
            return state.previewProduct
        },
        /**
         * @func 获取预览是否显示
         */
        getPreviewShow(state) {
            return state.previewShow
        },
    },

    actions: {
        /**
         * @func 检查购物车结算是否过期
         */
        async checkCheckoutTimeout({ commit, state }) {
            const currentTimestamp = new Date().getTime(); // 当前时间戳
            // 计算时间差
            const timeDifference = currentTimestamp - state.checkoutTimestamp
            // console.log(currentTimestamp, state.checkoutTimestamp, timeDifference)
            // 判断时间差是否小于 30 分钟（30 * 60 * 1000 毫秒）
            return timeDifference < CheckoutTimeout
        }
    },

    mutations: {
        /**
         * @func 设置预览商品
         */
        setPreviewProduct(state, product) {
            state.previewProduct = product
            state.previewShow = product ? true : false
        },
        /**
         * @func 设置购物车结算时间戳
         */
        setCheckoutTimeStamp(state, timestamp) {
            state.checkoutTimestamp = timestamp
        },
    }
}


export default uiStore
